import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const Api = {
    getNumDecisionsMade: async () => axios.get(SERVER_URL + '/decisions/count')
};
